<div
  ngpSlider
  class="wrapper"
  [class.is-disabled]="isDisabled()"
  [class.is-invalid]="errorState"
  [attr.aria-invalid]="errorState ? 'true' : null"
  [ngpSliderValue]="sliderValue"
  [ngpSliderMin]="min"
  [ngpSliderMax]="max"
  [ngpSliderStep]="step"
  [ngpSliderDisabled]="isDisabled()"
  (ngpSliderValueChange)="onValueChange($event)"
  (pointerdown)="onTrackPointerDown($event)"
>
  <div #track ngpSliderTrack class="track">
    <div ngpSliderRange class="range"></div>
    <div #thumb ngpSliderThumb ngpFocus class="thumb" [id]="effectiveId"></div>
  </div>
</div>
